import { Checkbox, Stack } from '@mui/material'
import React, { useState } from 'react'
import { J2Shoppingcard } from '@e3dc-react/icons'

interface Props {
  userId: number
  companyId: number
  notificationId?: number | null
  hasShop: boolean
  hasShopAccess: boolean
  onToggleShopAccess: (value: boolean, userId: number) => void
  hasNotificationAccess: boolean
  onToggleNotificationAccess: (value: boolean, companyId: number, userId: number, notificationId: number | null) => void
}

/**
 * This component can be used as part of a table. It displays access permissions and enables to change them.
 */
const CompanyAccessPermissionsField: React.VFC<Props> = props => {
  /** TODO: This feature is hidden until further notice. Change back when required */
  // const [hasNotificationAccess, setHasNotificationAccess] = useState(props.hasNotificationAccess)
  const [hasShopAccess, setHasShopAccess] = useState(props.hasShopAccess)

  /** TODO: This feature is hidden until further notice. Change back when required */
  // const handleNotificationChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
  //   setHasNotificationAccess(event.target.checked)
  //   props.onToggleNotificationAccess(event.target.checked, props.companyId, props.userId, props.notificationId ?? null)
  // }
  const handleShopChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setHasShopAccess(event.target.checked)
    props.onToggleShopAccess(event.target.checked, props.userId)
  }

  return (
    <Stack direction={'row'} spacing={1}>
      {/** TODO: This feature is hidden until further notice. Change back when required */}
      {/* <Stack direction={'row'} alignItems={'center'}>
        <H1Mail />
        <Checkbox checked={hasNotificationAccess} onChange={handleNotificationChange} />
      </Stack> */}
      {props.hasShop && (
        <>
          {/** TODO: This feature is hidden until further notice. Change back when required */}
          {/* <Box sx={{ flexDirection: 'row', py: 2 }}>
            <Divider orientation={'vertical'} />
          </Box> */}
          <Stack direction={'row'} alignItems={'center'}>
            <J2Shoppingcard />
            <Checkbox checked={hasShopAccess} onChange={handleShopChange} />
          </Stack>
        </>
      )}
    </Stack>
  )
}

export default CompanyAccessPermissionsField
